export default {
  props: {
    socialList: Array,
  },
}
